import { useContext } from 'react'
import { FeatureFlagsContext } from '@/context/featureFlagsContext'

/**
 * Read the runtime dashboard feature flags. Outside a FeatureFlagsProvider the
 * context default (all flags off) applies, so this is always safe to call.
 */
export function useFeatureFlags() {
  return useContext(FeatureFlagsContext)
}
